var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ blurred: _vm.isBackgroundBlurred },attrs:{"id":"app"}},[(_vm.pageHasHeader)?_c('app-header'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('sign-out-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }